import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  const ExternalLinkComponent = (url, text) => {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    );
  };

  return (
    <>
      {/* Animated Barber Pole Stripe */}
      <div className="barber-pole"></div>

      {/* Site Header */}
      <header className="site-header">
        <h1 className="site-title">
          <Link to="/">How To Bachelor</Link>
        </h1>
        <p className="site-description">Your Bachelor's Guidebook</p>
      </header>

      {/* Main Navigation */}
      <nav className="main-navigation">
        <button
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          onClick={toggleMenu}
        >
          <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <li>
            <Link
              to="/"
              className={isActive("/")}
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          <li>
            {ExternalLinkComponent("https://blog.howtobachelor.com/", "Blog")}
          </li>
          <li>
            {ExternalLinkComponent(
              "https://blog.howtobachelor.com/mvps",
              "MVPs"
            )}
          </li>
          <li>
            {ExternalLinkComponent(
              "https://blog.howtobachelor.com/advice",
              "Unsolicited Advice for Men"
            )}
          </li>
          <li>
            {ExternalLinkComponent(
              "https://blog.howtobachelor.com/privacy-policy",
              "Privacy Policy"
            )}
          </li>
          {/* <li><Link to="/mental-health" className={isActive('/mental-health')} onClick={() => setMenuOpen(false)}>Mental Health</Link></li>
          <li><Link to="/life-tips" className={isActive('/life-tips')} onClick={() => setMenuOpen(false)}>Life Tips</Link></li>
          <li><Link to="/recipes" className={isActive('/recipes')} onClick={() => setMenuOpen(false)}>Recipes</Link></li>
          <li><Link to="/hobbies" className={isActive('/hobbies')} onClick={() => setMenuOpen(false)}>Hobbies</Link></li>
          <li><Link to="/blog" className={isActive('/blog')} onClick={() => setMenuOpen(false)}>Blog</Link></li>
          <li><Link to="/about" className={isActive('/about')} onClick={() => setMenuOpen(false)}>About</Link></li> */}
        </ul>
      </nav>
    </>
  );
}

export default Header;
